var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.type ? "span" : "div",
    {
      tag: "component",
      staticClass: "show-tip",
      class: _vm.type ? "show-tip--field" : "show-tip--block",
    },
    [
      !_vm.type
        ? _c("div", { staticClass: "admin-tip admin-tip--block" }, [
            _c(
              "span",
              {
                staticClass: "admin-tip__icon",
                attrs: { "aria-hidden": "true" },
              },
              [_c("admin-icon", { attrs: { name: "info" } })],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "admin-tip__text" }, [
              _vm._v(_vm._s(_vm.trans(_vm.module + "." + _vm.tip))),
            ]),
          ])
        : _c("admin-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.trans(_vm.module + "." + _vm.tip),
                expression: "trans(module + '.' + tip)",
              },
            ],
            staticClass: "admin-tip__field-icon",
            attrs: {
              name: "help-circle",
              "aria-label": _vm.trans(_vm.module + "." + _vm.tip),
              role: "img",
              tabindex: "0",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }